import React from 'react'
import PropTypes from 'prop-types'
import ReactOuibounce from 'react-ouibounce'

import SubscribeModal from './subscribe-modal'
import '../css/global.css'

const Layout = ({ location, title, children }) => (
  <div>
    <main>{children}</main>
    <footer />
    <div className="hidden w-4 w-5 h-4 h-5 mt-6 mt-8 mt-16 mb-2 mb-3 mb-4 mb-8 font-sans font-serif text-lg text-xl text-2xl text-4xl italic font-bold font-extrabold font-black leading-tight leading-snug leading-relaxed leading-loose text-gray-900 lg:grid-cols-3 lg:grid-cols-4 fix-purge-issues" />
    <ReactOuibounce
      cookieName="sipreads-exit"
      cookieExpire={10}
      aggressive={false}
    >
      <SubscribeModal />
    </ReactOuibounce>
  </div>
)

Layout.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Array).isRequired,
}

export default Layout
